import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import Button from '@smart-tv/components/button/button';

import useGDPR from '@smart-tv/hooks/use-gdpr';

import styles from './gdpr-dialog.module.scss';

import { storePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';

export const GDPRDialogButtons: React.FC = () => {
  const { firstTimeLaunch, setFirstTimeLaunch, handleClose } = useGDPR();
  const { ref, focusSelf, focusKey } = useFocusable({ isFocusBoundary: true });

  React.useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  const acceptGdpr = React.useCallback(() => {
    if (firstTimeLaunch) {
      setFirstTimeLaunch(false);
      storePersistentData('accepted-gdpr', true);
    }
    handleClose();
  }, [firstTimeLaunch, handleClose, setFirstTimeLaunch]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles['gdpr-buttons']}>
        <Button
          onClick={acceptGdpr}
          data-testid={testIds.gdpr.button}
          className={styles['gdpr-button']}
        >
          OK
        </Button>
      </div>
    </FocusContext.Provider>
  );
};

export default GDPRDialogButtons;
